export const conditionalBoolQuery = (value: boolean | undefined, shouldFilter: boolean): boolean => {
    if (!shouldFilter) {
        return true;
    }

    return value ?? false;
};
